import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

// Import your pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ActivitiesPage from './pages/ActivitiesPage';
import DestinationsPage from './pages/DestinationsPage';
import BookingPage from './pages/BookingPage';
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import AccommodationPage from './pages/AccommodationPage';
import TransferPage from './pages/TransferPage';


// Helper component to scroll to top on page change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/destinations" element={<DestinationsPage />} />
        <Route path="/activities" element={<ActivitiesPage />} />
        <Route path="/accommodation" element={<AccommodationPage />} />
        <Route path="/transfers" element={<TransferPage />} />
        <Route path="/gallery" element={<GalleryPage />} />

        <Route path="/booking" element={<BookingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
      </Routes>
    </Router>
  );
}

export default App;